import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UserService from "../../services/UserService";

let initialState = {
    editors: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllMEditorsPageable = createAsyncThunk(
    'getAllMEditorsPageable',
    async ({ page, limit }, {getState, rejectWithValue, dispatch}) => {
        try {
            return await UserService.getMEditors(page, limit);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const mEditorsListSlice = createSlice({
    name: 'mEditorsListSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllMEditorsPageable.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllMEditorsPageable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.editors = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllMEditorsPageable.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.editors = [];
                state.hasMore = false;
            })
    }
});

export const {} = mEditorsListSlice.actions;

export default mEditorsListSlice.reducer;